<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-alert/>
        <p>
          This requirement asks you to review, at least once per year, records of information system activity, such as audit logs, access reports, and security incident tracking reports to ensure patient records are being accessed in a manner consistent with your office policies and procedures.
          Audit logs, for example, track every user’s activity while they are logged into an EHR system.
        </p>
        <hm-note>
          <u>Example</u>: During a system activity review you discover an employee had logged-in to your cloud-based EHR system on a Saturday, a day in which no one should be in the office. You later determine the employee accessed the EHR from
          their home which is prohibited by your policies and procedures. You will want to document the &quot;security-significant event&quot; that occurred and that you plan to provide additional Workstation Use training for the employee.
        </hm-note>
        <hm-spinner v-if="!ready"/>
      </b-col>
    </b-row>

    <b-row v-show="ready">
      <b-col>
        <b-button type="button" variant="primary" class="px-4" to="/activity-edit">New System Activity Review</b-button>
      </b-col>
    </b-row>

    <b-row class="pt-4" v-show="ready">
      <b-col>
        <b-table class="p-1" responsive bordered hover show-empty empty-text="No Activities" :items="activities" :fields="columns" @row-clicked="rowClick">
          <template slot="cell(date)" slot-scope="data">
            <span>{{data.value|formatDate('YYYY-MM-DD')}}</span>
          </template>
          <template slot="cell(findings)" slot-scope="data">
            <span v-if="securityEvent(data.item)">
              <i class="icon-exclamation text-danger"></i> Security event discovered
            </span>
            <span v-else>
              <i class="icon-check text-success"></i> All is good!
            </span>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { practiceService } from '@/services'

export default {
  name: 'ActivityList',
  data() {
    return {
      activities: [],
      columns: [{
        key: 'date',
        label: 'Date',
        sortable: true
      }, {
        key: 'reviewer',
        label: 'Reviewer',
        sortable: true
      }, {
        key: 'findings',
        label: 'Findings'
      }],
      ready: false
    }
  },
  methods: {
    ...mapActions({
      alertException: 'alert/exception'
    }),
    rowClick(item, index) {
      this.$router.push({ name: 'ActivityEdit', params: { id: item.id } });
    },
    securityEvent(item) {
      return (item.logins === 'yes' || item.fileAccess === 'yes' || item.incidents === 'yes' || item.accounts === 'yes');
    }
  },
  created() {
    this.ready = false;

    practiceService.getActivity()
      .then(data => {
        this.activities = data;
      })
      .catch(err => {
        this.alertException({ err, message: 'Error loading activities.' });
      }).finally(() => {
        this.ready = true;
      })
  }
}
</script>
